


import Vue from 'vue';
import InputUnit from "./InputUnit.vue";
import Tooltip from "./Tooltip.vue";

interface Data {
	gpfupEnable: boolean
	gpfupEnableCrop: boolean
	gpfupEnableSorting: boolean
	gpfupCropRequired: boolean
	gpfupAspectRatioAntecedent: number | undefined
	gpfupAspectRatioConsequent: number | undefined
	gpfupMaxWidth: number | undefined
	gpfupMaxHeight: number | undefined
	gpfupMinWidth: number | undefined
	gpfupMinHeight: number | undefined
	gpfupExactWidth: number | undefined
	gpfupExactHeight: number | undefined
}

const data: Data = {
	gpfupEnable: false,
	gpfupEnableCrop: false,
	gpfupEnableSorting: false,
	gpfupCropRequired: false,
	gpfupAspectRatioAntecedent: undefined,
	gpfupAspectRatioConsequent: undefined,
	gpfupMaxWidth: undefined,
	gpfupMaxHeight: undefined,
	gpfupMinWidth: undefined,
	gpfupMinHeight: undefined,
	gpfupExactWidth: undefined,
	gpfupExactHeight: undefined,
};

/** Used for resetting data */
const defaultData = {...data};

export default Vue.extend({
	name: 'GPFUPSettings',
	props: [
		'field',
		'strings',
	],
	components: {
		InputUnit,
		Tooltip,
	},
	data() {
		return data;
	},
	/**
	 * Listen for  changes in observables/data and send them to Gravity Forms.
	 */
	created: function () {
		for (const fieldSetting of Object.keys(data)) {
			this.$watch(fieldSetting, (val, oldVal) => {
				try {
					if (typeof val !== 'undefined') {
						window.SetFieldProperty(fieldSetting, JSON.parse(JSON.stringify(val)));
					}
				} catch (e) {
					console.warn(e);
				}
			}, {deep: true});
		}
	},
	watch: {
		field: {
			handler: function (field, prevField) {
				/**
				 * This is needed due to the watch on gpfupEnable not firing at the right time if
				 * upgrading a single-file
				 */
				this.toggleMultiFileNoticeAndDisable();

				if (prevField && field.id === prevField.id) {
					return;
				}

				this.syncFieldToData();
			},
			deep: true,
		},
		gpfupEnable: function(enabled) {
			// @ts-ignore
			if (!this.field?.['multipleFiles'] && enabled) {
				if (window.has_entry(this.field.id)) {
					// @ts-ignore
					const confirmed = confirm(this.strings?.['upgrade_multiple_files']);
					if (!confirmed) {
						// @ts-ignore
						this.$nextTick(() => {
							// @ts-ignore
							this.gpfupEnable = false;
						});

						return;
					}

					window.SetFieldProperty('gpfupUpgradeToMultipleFiles', true);
					window.SetFieldProperty('maxFiles', '1');
				}

				// Convert from single file to multiple uploads.
				window.SetFieldProperty('multipleFiles', true);

				jQuery("#field_multiple_files").prop("checked", true);
				window.ToggleMultiFile();
			}

			this.toggleMultiFileNoticeAndDisable();
		}
	},
	computed: {
		usingExact: function (): boolean {
			return !!(this.gpfupExactWidth || this.gpfupExactHeight);
		},
		usingMin: function (): boolean {
			return !!(this.gpfupMinWidth || this.gpfupMinHeight);
		},
		usingMax: function (): boolean {
			return !!(this.gpfupMaxWidth || this.gpfupMaxHeight);
		},
		usingRatio: function (): boolean {
			return !!(this.gpfupAspectRatioAntecedent || this.gpfupAspectRatioConsequent);
		},
		lockExact: function () {
			return (this.usingMax || this.usingMin || this.usingRatio);
		},
		lockMin: function () {
			return this.usingExact;
		},
		lockMax: function () {
			return this.usingExact;
		},
		lockRatio: function () {
			return this.usingExact;
		},
	},
	methods: {
		toggleMultiFileNoticeAndDisable() {
			jQuery('#gpfup-multi-file-requirement-notice').remove();

			const $multipleFiles = jQuery('#field_multiple_files');

			if (this.gpfupEnable) {
				const $notice = jQuery(`<div id="gpfup-multi-file-requirement-notice" class="gform-accessibility-warning field_setting gform-alert gform-alert--accessibility gform-alert--inline">
					<span class="gform-icon gform-icon--password gform-alert__icon"></span>
					<div class="gform-alert__message-wrap">
						<p class="gform-alert__message" style="margin: 0;">${this.strings?.['multi_file_requirement']}</p>
					</div>
				</div>`);

				$multipleFiles.prop('disabled', true);
				$notice.insertBefore('#gform_multiple_files_options');
			} else {
				$multipleFiles.prop('disabled', window.has_entry(this.field.id));
			}
		},
		syncFieldToData() {
			var vm = this;

			Object.assign(vm.$data, defaultData);

			for (const fieldSetting of Object.keys(data)) {
				if (!window.field) {
					continue;
				}

				if (fieldSetting in window.field) {
					vm.$data[fieldSetting] = window.field[fieldSetting];
				}
			}
		},
	}
});
